// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Apps: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M11.29,20.48H0.05v-7.78h11.24V20.48z M1.45,19.08h8.44v-4.97H1.45V19.08z"/>
<path d="M23.95,20.48H12.71v-7.78h11.24V20.48z M14.11,19.08h8.44v-4.97h-8.44V19.08z"/>
<path d="M11.29,11.29H0.05V3.52h11.24V11.29z M1.45,9.89h8.44V4.92H1.45V9.89z"/>
<path d="M23.95,11.29H12.71V3.52h11.24V11.29z M14.11,9.89h8.44V4.92h-8.44V9.89z"/>
</svg>;
};

export default React.memo(Apps);
